import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { ROUTE } from '../common/constants';

import { routePaths } from './Router';

const isUnknownRoute = (routeNames: string[], pathname: string): boolean =>
    !routeNames.some(route => pathname.startsWith(route));

export const DefaultRedirect = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (isUnknownRoute(routePaths, pathname)) {
            navigate(ROUTE.ROOT_ROUTE);
        }
    }, [pathname]);

    return null;
};
